import { useContext, useEffect } from "react"

import { ContentPage } from "../../components/contentful"
import { getI18n, getPageContents } from "../../components/contentful/pageProps"
import { Context } from "../../context"

const Locations = ({ content, states, preview }) => {
    const { state: { states: [...stateList] = [], content: { dmaName = "", msoName = "" } = {} } = {}, dispatch } =
        useContext(Context)

    useEffect(() => {
        if (stateList?.length || !states?.length) return

        dispatch({
            type: "STATES",
            payload: states,
        })
    }, [dispatch, states, stateList])

    useEffect(() => {
        dispatch({
            type: "STORES",
            payload: [],
        })

        dispatch({
            type: "CURRENT_STORE",
            payload: null,
        })

        if (dmaName || msoName) {
            dispatch({
                type: "CONTENT",
                payload: {
                    dmaName: null,
                    msoName: null,
                },
            })
        }
    }, [dispatch, dmaName, msoName])

    return <ContentPage {...{ content, preview }} />
}

export async function getStaticProps({ defaultLocale, ...props }) {
    const i18next = await getI18n({ locale: defaultLocale })
    const states = i18next.t("states")

    return await getPageContents({ states, ...props }, { name: "Locations" })
}

export default Locations
